import { AUTH_ERROR, CURRENT_USER, SIGN_IN, SIGN_OUT, SIGN_UP, USER_LOADING } from "./types";

const isEmpty = require("is-empty");

const initialState = {
  isAuthentication: false,
  loading: false,
  userAuth: {},
  signup: {},
  error: null
}


const AuthReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SIGN_UP: 
      return {
        ...state,
        signup: payload,

        error: null
      }
    case SIGN_IN: 
      return {
        ...state,
        signin: payload,
      }
    case CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(payload),
        userAuth: payload
      };
    case SIGN_OUT:
      return {
          ...state,
          userAuth: null,
          error: null
      }
    case USER_LOADING:
      return {
        ...state,
        loading: true
      };
    case AUTH_ERROR:
      return {
          ...state,
          error: payload
      }
    default:
      return state;
    
  }
}
export default AuthReducer;